module.exports = __webpack_public_path__ + "static/media/switch-shifts.3fa7a8ce.svg";